import type { CustomFlowbiteTheme } from 'flowbite-react';

export const checkboxTheme: CustomFlowbiteTheme['checkbox'] = {
  root: {
    base: 'h-4 w-4 rounded border border-titan-night-300 bg-titan-night-100 focus:ring-2 focus:ring-titan-folly-500 text-titan-folly-600',
  },
};
